import * as moment from 'moment'
import * as React from 'react'
import { Button } from '~/components/_atoms/index'
import YnsIcon from '~/components/icons/YnsIcon'
import Spinner from '~/components/shared/Spinner'
import { useIsMobile } from '~/hooks/useMediaQuery'
import { useTranslation } from '~/hooks/useTranslation'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/lib/ui/dropdown-menu'
import { getApi } from '~/util/api'

export function NameCell({ row, table }) {
  const chat = row.original
  const isMobile = useIsMobile()
  if (isMobile) return <MobileCell chat={chat} table={table} />
  return (
    <div className="flex flex-col gap-1 pr-2">
      <div className="line-clamp-1 text-base font-bold">{chat.name}</div>
    </div>
  )
}

const MobileCell = ({ chat, table }) => {
  const { name, chat_type, started_at, id } = chat
  const formattedDate = moment(started_at).format('MMMM D, YYYY - h:mm A')
  const { t } = useTranslation()
  const setSelectedChat = table.options.meta?.setSelectedChat
  const setChatHistories = table.options.meta?.setChatHistories
  const toast = table.options.meta?.toast
  const [isEmailing, setIsEmailing] = React.useState(false)
  const [isDeleting, setIsDeleting] = React.useState(false)

  const handleEmailChat = async () => {
    setIsEmailing(true)
    try {
      const response = await getApi().post(
        `/chat_histories/${id}/email_chat_conversation`,
      )
      if (response.data.success) {
        toast({ description: response.data.message })
      }
    } catch (error) {
      console.error('Error emailing chat conversation:', error)
      toast({
        description: t('chat_histories.failed_to_email_chat'),
      })
    } finally {
      setIsEmailing(false)
    }
  }

  const handleDeleteChat = async () => {
    if (window.confirm(t('chat_histories.delete_chat_confirm'))) {
      setIsDeleting(true)
      try {
        const response = await getApi().delete(
          `/chat_histories/${id}/api_delete`,
        )
        if (response.data.success) {
          toast({ description: response.data.message })
          // Refresh chat histories after successful deletion
          const historiesResponse = await getApi().get(
            '/coach_services/chat_histories',
          )
          if (historiesResponse.status === 200) {
            setChatHistories(historiesResponse.data.chat_histories)
          }
        }
      } catch (error) {
        console.error('Error deleting chat:', error)
        toast({
          description: t('chat_histories.failed_to_delete_chat'),
        })
      } finally {
        setIsDeleting(false)
      }
    }
  }
  return (
    <div className="flex flex-col gap-2 pr-2">
      <div className="flex justify-between">
        <div className="line-clamp-1 text-base font-bold">{name}</div>
        <DropdownMenu>
          <DropdownMenuTrigger>
            <YnsIcon name="ellipsis-horizontal" />
          </DropdownMenuTrigger>
          <DropdownMenuContent>
            <DropdownMenuItem>
              <Button
                variant="link"
                onClick={() => handleEmailChat()}
                disabled={isEmailing}
              >
                <div className="flex items-center gap-2">
                  {t('chat_histories.email')}
                  {isEmailing && <Spinner show size={4} />}
                </div>
              </Button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Button
                variant="link"
                href={`/chat_histories/${id}/download_chat_conversation?format=pdf`}
                target="_blank"
              >
                {t('chat_histories.download')}
              </Button>
            </DropdownMenuItem>
            <DropdownMenuItem>
              <Button
                variant="link"
                onClick={() => handleDeleteChat()}
                disabled={isDeleting}
              >
                <div className="flex items-center gap-2">
                  {t('chat_histories.delete')}
                  {isDeleting && <Spinner show size={4} />}
                </div>
              </Button>
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
      <div>{formattedDate}</div>
      <div className="flex flex-col">{t(`TypeCell.${chat_type}`)}</div>
      <div className="w-full self-center">
        <Button
          variant="outline"
          color="secondary"
          onClick={() => setSelectedChat(chat)}
          className="w-full self-center"
        >
          {t('chat_histories.view')}
        </Button>
      </div>
    </div>
  )
}
